import {
  DEFAULT_CHATBOT_FRAME_URL,
  DEFAULT_VERSION_CHECK_PATH,
} from "../constants";
import { isLocalHostMode } from "./url.helpers";

export const isProductionEnv = (): boolean =>
  process.env.NODE_ENV === "production";

export const apiBaseUrl = (): string | undefined =>
  process.env.REACT_APP_LANDING_API_URL || process.env.REACT_APP_API_URL;

export const isLandingsApiApp = (): boolean =>
  Boolean(process.env.REACT_APP_LANDING_API_URL);

export const googleApiKey = (): string | undefined =>
  process.env.REACT_APP_GOOGLE_API_KEY;

export const mapboxAccessToken = (): string | undefined =>
  process.env.REACT_APP_MAPBOX_TOKEN;

export const shouldDebugForms = (): boolean | undefined =>
  process.env.REACT_APP_SHOULD_DEBUG_FORMS === "true";

export const shouldDebugReactTable = (): boolean | undefined =>
  process.env.REACT_APP_SHOULD_DEBUG_REACT_TABLE === "true";

export const isJenkinsCustomEnv = (): boolean | undefined =>
  process.env.REACT_APP_JENKINS_TEST_ENV === "1";

export const isJenkinsTestimIoCustomEnv = (): boolean | undefined =>
  process.env.REACT_APP_JENKINS_TEST_AUTO_ENV === "1";

export const googleTagManagerKey = (): string | undefined =>
  process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID;

export const isGoogleTagManagerEnabled = (): boolean =>
  process.env.REACT_APP_GOOGLE_TAG_MANAGER_ENABLED === "true";

export const wsPath = (): string | undefined => process.env.REACT_APP_WS_PATH;

export const msEntraClientId = (): string =>
  process.env.REACT_APP_MS_ENTRA_CLIENT_ID ?? "";

export const recaptchaEnterpriseSiteKey = (): string =>
  process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY ?? "";

export const chatBotIframeUrl = (): string =>
  process.env.REACT_APP_CHATBOT_FRAME_URL ?? DEFAULT_CHATBOT_FRAME_URL;

export const getBuildVersionCheckPath = (): string =>
  process.env.REACT_APP_BUILD_VERSION_CHECK_PATH || DEFAULT_VERSION_CHECK_PATH;

export const getDownloadPassengerAppGoogleStorePath = (): string =>
  process.env.REACT_APP_DOWNLOAD_PASSENGER_APP_GOOGLE_STORE_PATH || "#";

export const getDownloadPassengerAppIosStorePath = (): string =>
  process.env.REACT_APP_DOWNLOAD_PASSENGER_APP_IOS_STORE_PATH || "#";

export const isLocalOrJenkinsMode = (): boolean => {
  return (
    isJenkinsCustomEnv() || isJenkinsTestimIoCustomEnv() || isLocalHostMode()
  );
};

export const isTokenInfoLoggingMode = (): boolean => {
  return window.location.hash?.includes("log_token_expiration=1");
};

export const isLocalOrJenkinsModeOrQsDebugLog = (): boolean => {
  return (
    isLocalOrJenkinsMode() || window.location.hash?.includes("show_debug_log=1")
  );
};
